import { ChildGender } from "~/types";

export const formatAge = (
  age?: number | null | undefined,
  gender?: ChildGender,
): string => {
  if (age === null || age === undefined) return "-";
  if (age === 0) {
    if (gender === "girl") return "nou-născută";
    return "nou-născut";
  }
  return `${age} ${age === 1 ? "anișor" : "ani"}`;
};
